import { DEFAULT_TENANT, sanitizeTenantId } from './tenantId';

function parseHostMap(raw: string | undefined): Record<string, string> {
  if (!raw) {
    return {};
  }

  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return parsed as Record<string, string>;
    }
  } catch {
    return {};
  }

  return {};
}

export function detectTenant(): string {
  if (typeof window !== 'undefined') {
    const query = new URLSearchParams(window.location.search);
    const queryTenant = query.get('tenant') || query.get('vendor');
    if (queryTenant) {
      const safeQueryTenant = sanitizeTenantId(queryTenant);
      if (safeQueryTenant) {
        return safeQueryTenant;
      }
    }

    const envVendor = sanitizeTenantId(process.env.REACT_APP_VENDOR);
    if (envVendor) {
      return envVendor;
    }

    const hostMap = parseHostMap(process.env.REACT_APP_TENANT_HOST_MAP);
    const hostTenant = sanitizeTenantId(hostMap[window.location.hostname.toLowerCase()]);
    if (hostTenant) {
      return hostTenant;
    }
  }

  return sanitizeTenantId(process.env.REACT_APP_TENANT) || DEFAULT_TENANT;
}
